import React from 'react';
import { Mail, Package, RotateCcw } from 'lucide-react';

const Shipping = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="shipping-page">
      {/* Header */}
      <div className="bg-plumo-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
          <h1 
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 500,
              fontStyle: 'italic',
              fontSize: 'clamp(36px, 5vw, 56px)',
              color: '#1A1814',
            }}
          >
            Shipping, returns & contact
          </h1>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Shipping */}
          <div className="border-t border-plumo-black/10 pt-8" data-testid="shipping-info">
            <div className="flex items-center gap-3 mb-6">
              <Package className="w-5 h-5 text-plumo-gold" />
              <h2 
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 500,
                  fontStyle: 'italic',
                  fontSize: '22px',
                  color: '#1A1814',
                }}
              >
                Shipping
              </h2>
            </div>
            <div 
              className="space-y-4"
              style={{
                fontFamily: "'Space Mono', monospace",
                fontSize: '13px',
                color: 'rgba(26,24,20,0.7)',
                lineHeight: 1.7,
              }}
            >
              <p>all orders ship within 2-3 business days.</p>
              <p style={{ color: '#1A1814' }}>free shipping on orders over $50.</p>
              <p>standard delivery 5-7 business days.</p>
              <p>express available at checkout.</p>
            </div>
          </div>

          {/* Returns */}
          <div className="border-t border-plumo-black/10 pt-8" data-testid="returns-info">
            <div className="flex items-center gap-3 mb-6">
              <RotateCcw className="w-5 h-5 text-plumo-gold" />
              <h2 
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 500,
                  fontStyle: 'italic',
                  fontSize: '22px',
                  color: '#1A1814',
                }}
              >
                Returns
              </h2>
            </div>
            <div 
              className="space-y-4"
              style={{
                fontFamily: "'Space Mono', monospace",
                fontSize: '13px',
                color: 'rgba(26,24,20,0.7)',
                lineHeight: 1.7,
              }}
            >
              <p>we accept returns within 14 days of delivery.</p>
              <p>items must be unworn and in original packaging.</p>
              <p style={{ color: '#1A1814' }}>final sale items cannot be returned.</p>
              <p>email us to start a return.</p>
            </div>
          </div>

          {/* Contact */}
          <div className="border-t border-plumo-black/10 pt-8" data-testid="contact-info">
            <div className="flex items-center gap-3 mb-6">
              <Mail className="w-5 h-5 text-plumo-gold" />
              <h2 
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 500,
                  fontStyle: 'italic',
                  fontSize: '22px',
                  color: '#1A1814',
                }}
              >
                Contact
              </h2>
            </div>
            <div 
              className="space-y-4"
              style={{
                fontFamily: "'Space Mono', monospace",
                fontSize: '13px',
                color: 'rgba(26,24,20,0.7)',
                lineHeight: 1.7,
              }}
            >
              <p>for questions email</p>
              <a 
                href="mailto:hello@shopplumo.com" 
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 500,
                  fontStyle: 'italic',
                  fontSize: '18px',
                  color: '#1A1814',
                }}
                className="block hover:opacity-70 transition-opacity"
                data-testid="contact-email"
              >
                hello@shopplumo.com
              </a>
              <p>we respond within 24-48 hours.</p>
            </div>
          </div>
        </div>

        {/* Bottom Note */}
        <div className="mt-20 text-center">
          <p 
            style={{
              fontFamily: "'Dawning of a New Day', cursive",
              fontSize: '24px',
              color: '#C9A961',
            }}
          >
            questions? we've got you.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Shipping;
